<template>
  <UColorModeImage
    light="/logo.svg"
    dark="/logo-dark.svg"
    alt="Logo"
    height="28"
  />
</template>
